const env = window.env ?? process.env;

export const configuration = {
  NODE_ENV: env.NODE_ENV,
  API_URL: env.REACT_APP_API_URL,
};
